
import { useAuth0 } from '@auth0/auth0-react';
import Urls from 'Containers/Urls';
import React, { PropsWithChildren, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { deepLink } from 'Utils/deepLink';
import { GlobalLoadingCaller } from 'Utils/GlobalLoading';
import { isFromAppMobile } from 'Utils/mobile';

interface AuthenticatedProps {
  /**
   * Use to prevent redirect to Landing page
   * and use loginWithRedirect in case
   * user is not authenticated with appState.
   */
  skipRedirect?: boolean
}

export const Authenticated: React.FC<PropsWithChildren<AuthenticatedProps>> = (
  { children, skipRedirect = false },
) => {
  const history = useHistory();
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();

  const isMobileApp = isFromAppMobile();
  const urlOrigin = document.referrer;
  const isOtherKueskiApp = urlOrigin.includes('cuenta') || urlOrigin.includes('prestamo');
  const universalRegisterRedirect = !isAuthenticated && isOtherKueskiApp;

  useEffect(() => {
    if (isLoading || isMobileApp) return;

    if (!isAuthenticated && (!skipRedirect && !isOtherKueskiApp)) {
      deepLink.set(`${window.location.pathname}${window.location.search}`);
      history.push(Urls.landing);
    }
  }, [isMobileApp, skipRedirect, isOtherKueskiApp, isAuthenticated, isLoading]);

  useEffect(() => {
    if (isLoading || isMobileApp) return;

    if (!isAuthenticated && (skipRedirect || universalRegisterRedirect)) {
      const { origin, pathname, search } = window.location;
      loginWithRedirect({
        appState: { returnTo: origin + pathname + search },
      });
    }
  }, [isAuthenticated, skipRedirect, isLoading, isMobileApp, universalRegisterRedirect]);

  if (isLoading || (skipRedirect && !isAuthenticated)) {
    return <GlobalLoadingCaller queryKey={['ROUTER_WRAPPER', 'AUTHENTICATED']} />;
  }

  return <>{children}</>;
};

Authenticated.defaultProps = {
  skipRedirect: false,
};
